const insightArticles = [
  {
    slug: "quanto-custa-criar-site-portugal",
    path: "/insights/quanto-custa-criar-site-portugal",
    title: "Quanto custa criar um site em Portugal? | BezierClick",
    description: "Guia prático para perceber o que influencia o orçamento de um website empresarial em Portugal, sem promessas vagas nem preços escondidos.",
    h1: "Quanto custa criar um site em Portugal?",
    category: "Websites",
    author: "BezierClick",
    language: "pt-PT",
    publishedAt: "2026-08-20",
    updatedAt: "2026-08-20",
    readingTime: "6 min",
    summary:
      "O custo de um site depende do objetivo comercial, número de páginas, conteúdo, integrações, SEO, performance e manutenção. O mais importante é perceber se o site deve apenas apresentar a empresa ou gerar oportunidades comerciais.",
    tableOfContents: [
      "O que muda o valor de um website",
      "Site simples ou website empresarial",
      "Custos que muitas empresas esquecem",
      "Como pedir um orçamento mais claro",
    ],
    sections: [
      {
        title: "O que muda o valor de um website",
        body:
          "Um website institucional simples tem um esforço muito diferente de uma plataforma preparada para captar leads, integrar formulários, medir conversões e apoiar campanhas. Antes do preço, deve existir uma decisão sobre objetivo: credibilidade, vendas, pedidos de contacto, recrutamento ou suporte comercial.",
      },
      {
        title: "Site simples ou website empresarial",
        body:
          "Um site simples pode resolver presença básica. Um website empresarial precisa de estrutura de serviços, copy orientada à decisão, SEO técnico, performance, analytics, páginas de conversão e uma experiência mobile cuidada. É essa diferença que normalmente separa um custo baixo de um investimento com retorno potencial.",
      },
      {
        title: "Custos que muitas empresas esquecem",
        body:
          "Domínio, alojamento, email, manutenção, imagens, textos, configuração de analytics, Search Console, segurança e futuras melhorias também contam. Um orçamento sério deve separar o que é criação inicial, o que é recorrente e o que pode ser evoluído depois.",
      },
      {
        title: "Como pedir um orçamento mais claro",
        body:
          "Explique o problema que quer resolver, envie exemplos de sites que fazem sentido, indique se já tem conteúdo, diga que ferramentas precisa de integrar e defina prioridades. Isto reduz ambiguidade e ajuda a criar uma proposta mais justa.",
      },
    ],
    faq: [
      {
        question: "Um site barato pode funcionar?",
        answer:
          "Pode funcionar quando o objetivo é muito simples. Se a empresa precisa de captar leads, aparecer melhor no Google ou integrar processos, normalmente é preciso mais estratégia, conteúdo e implementação técnica.",
      },
      {
        question: "Vale a pena investir em SEO logo no inicio?",
        answer:
          "Sim, pelo menos na base técnica: estrutura, performance, URLs, headings, metadata e conteúdo claro. SEO feito depois costuma exigir retrabalho.",
      },
    ],
    internalLinks: [
      { href: "/criacao-de-sites", label: "Criação de sites" },
      { href: "/planos", label: "Planos e preços" },
      { href: "/diagnostico-digital", label: "Pedir diagnóstico gratuito" },
    ],
    cta: {
      label: "Pedir diagnóstico gratuito",
      href: "/diagnostico-digital",
      text: "Quer perceber que tipo de website faz sentido para a sua empresa antes de pedir orçamento?",
    },
  },
  {
    slug: "o-que-e-tech-partner",
    path: "/insights/o-que-e-tech-partner",
    title: "O que é um Tech Partner? | BezierClick",
    description: "Entenda como um Tech Partner ajuda PMEs a evoluir websites, sistemas, automações e integrações sem contratar uma equipa interna.",
    h1: "O que é um Tech Partner?",
    category: "Tech Partner",
    author: "BezierClick",
    language: "pt-PT",
    publishedAt: "2026-08-20",
    updatedAt: "2026-08-20",
    readingTime: "5 min",
    summary:
      "Um Tech Partner acompanha a empresa de forma recorrente para transformar necessidades digitais em melhorias práticas: website, automação, software, integrações, suporte e evolução contínua.",
    tableOfContents: [
      "Quando uma PME precisa de Tech Partner",
      "O que pode ser acompanhado",
      "Diferença entre projeto pontual e parceria",
      "Como começar com baixo risco",
    ],
    sections: [
      {
        title: "Quando uma PME precisa de Tech Partner",
        body:
          "A necessidade aparece quando existem várias pequenas dores digitais: site parado, processos manuais, ferramentas que não comunicam, ideias de automação sem dono técnico ou melhorias sempre adiadas por falta de equipa.",
      },
      {
        title: "O que pode ser acompanhado",
        body:
          "Um acompanhamento pode incluir manutenção do website, novas páginas, analytics, integrações, automatizações, suporte a ferramentas internas, pequenas evoluções de software e avaliação de oportunidades com IA.",
      },
      {
        title: "Diferença entre projeto pontual e parceria",
        body:
          "Um projeto pontual resolve uma entrega específica. Uma parceria cria continuidade: prioridades mensais, evolução gradual, suporte técnico e capacidade de responder a necessidades que surgem com o crescimento da empresa.",
      },
      {
        title: "Como começar com baixo risco",
        body:
          "O melhor ponto de partida é diagnosticar o estado atual, escolher uma prioridade concreta e medir se a melhoria reduz trabalho manual, aumenta clareza comercial ou melhora a operação.",
      },
    ],
    faq: [
      {
        question: "Tech Partner substitui uma equipa interna?",
        answer:
          "Nem sempre. Para muitas PMEs, funciona como equipa externa recorrente. Para empresas maiores, pode complementar a equipa interna em execução, automação e evolução web.",
      },
      {
        question: "Preciso de começar com um contrato longo?",
        answer:
          "Não necessariamente. O ideal é começar com diagnóstico, prioridades claras e um plano de evolução que possa ser ajustado com base no valor entregue.",
      },
    ],
    internalLinks: [
      { href: "/tech-partner", label: "Conhecer Tech Partner" },
      { href: "/automacao-empresarial", label: "Automação empresarial" },
      { href: "/diagnostico-digital", label: "Pedir diagnóstico gratuito" },
    ],
    cta: {
      label: "Falar sobre Tech Partner",
      href: "/tech-partner",
      text: "A sua empresa tem várias necessidades digitais paradas por falta de equipa técnica?",
    },
  },
];

const getInsightBySlug = (slug) =>
  insightArticles.find((article) => article.slug === slug) || null;

module.exports = {
  insightArticles,
  getInsightBySlug,
};
